// extracted by mini-css-extract-plugin
export default {"value":"_3C4X-FjlolCLE4qTGmU2aw=="};